import { getSelfServerOrigin } from '../host'
import { IS_DEV, IS_PREVIEW, isBrowser } from '../env'
import { dynamicAxios } from '../dynamics/axios'

import type { TSupportedHostKey } from '@loc/hosts/src/constants'

export async function fetchCacheData(
  supportedHostKey: TSupportedHostKey,
  cacheDataKeys?: string[],
) {
  // 当纯浏览器运行时，如果没有 cacheDataKeys 或者 cacheDataKeys 都在本地存在缓存时，
  // 直接使用本地缓存。
  if (
    isBrowser() &&
    window._cacheData &&
    (!cacheDataKeys ||
      cacheDataKeys.every((item) => !!window._cacheData?.[item]))
  ) {
    if (IS_DEV || IS_PREVIEW) {
      // eslint-disable-next-line no-console
      console.log(`fetchCacheData return window._cacheData:`, window._cacheData)
    }
    return window._cacheData
  }

  const origin = getSelfServerOrigin()

  const cacheDataResult = await dynamicAxios((axios) => {
    return axios.post(
      `${origin}/api/_data`,
      { hostKey: supportedHostKey, cacheDataKeys },
      {
        proxy: false,
      },
    )
  })

  return cacheDataResult.data
}
